<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/mbg.svg'), class: 'full-logo', name: 'MultiBankGroup', url: 'https://multibank.io/' },
      { logo: require('@/assets/logos/ibc.png'), class: 'logo ibc', name: 'IBC Group', url: 'https://www.ibcgroup.io/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/singapore/sponsors/coinlist.svg'), class: 'full-logo', name: 'CoinList', url: 'https://coinlist.co/' },
      { logo: require('@/assets/logos/binance.png'), class: 'full-logo', name: 'Binance', url: 'https://www.binance.com/' },
      { logo: require('@/assets/logos/animoca.png'), class: 'full-logo wolf', name: 'Animoca Brands', url: 'https://www.animocabrands.com/' },
      { logo: require('@/assets/logos/tyregate.png'), class: 'full-logo', name: 'TyreGate Capital', url: 'https://www.tyregatecapital.com/' },
      { logo: require('@/assets/logos/emirates.png'), class: 'full-logo', name: 'Emirates Family Office', url: 'https://emiratesfoa.com/' },
      { logo: require('@/assets/logos/wolfallstreets.png'), class: 'logo wolf', name: 'The Wolf of All Streets', url: 'https://www.thewolfofallstreets.io/' },
      { logo: require('@/assets/logos/keturah.png'), class: 'full-logo', name: 'Keturah by MAG', url: 'https://mag.ae/portfolio/keturah-reserve' },
      { logo: require('@/assets/logos/mavryk.svg'), class: 'logo', name: 'Mavryk', url: 'https://mavryk.org/' },
      { logo: require('@/assets/logos/tether.png'), class: 'full-logo', name: 'Tether', url: 'https://tether.to/en/' },
      { logo: require('@/assets/logos/humanity.png'), class: 'full-logo', name: 'Humanity Protocol', url: 'https://www.humanity.org/' },
      { logo: require('@/assets/logos/dippy.png'), class: 'logo ibc', name: 'DippyAI', url: 'https://www.dippy.ai/' },
      { logo: require('@/assets/logos/bittensor.svg'), class: 'full-logo', name: 'Bittensor', url: 'https://www.bittensor.ai/subnets/17' },
      { logo: require('@/assets/logos/t-rize.svg'), class: 'logo ibc', name: 'T-Rize', url: 'https://www.t-rize.io/' },
      { logo: require('@/assets/logos/inference.svg'), class: 'full-logo', name: 'Inference', url: 'https://inferencelabs.com/' },
      { logo: require('@/assets/logos/contango.svg'), class: 'full-logo', name: 'Contango', url: 'https://www.contango.digital/' },
      { logo: require('@/assets/logos/openeden.svg'), class: 'full-logo', name: 'OpenEden', url: 'https://openeden.com/' },
      { logo: require('@/assets/logos/ascendex.png'), class: 'logo', name: 'AscendEX', url: 'https://ascendex.com/en' },
      { logo: require('@/assets/logos/bitget.svg'), class: 'full-logo', name: 'Bitget', url: 'https://www.bitget.com/' },
      { logo: require('@/assets/logos/orderly.svg'), class: 'full-logo', name: 'Orderly', url: 'https://orderly.network/' },
      { logo: require('@/assets/logos/bitmart.svg'), class: 'full-logo', name: 'BitMart', url: 'https://www.bitmart.com/en-US' },
      { logo: require('@/assets/logos/muhdo.png'), class: 'full-logo', name: 'Muhdo', url: 'https://muhdo.com/' },
      { logo: require('@/assets/logos/meslo.svg'), class: 'full-logo', name: 'Meslo', url: 'https://meslo.com/' },
      { logo: require('@/assets/logos/genomes.png'), class: 'full-logo', name: 'Genomes.io', url: 'https://www.genomes.io/' },
      { logo: require('@/assets/logos/raiinmaker.png'), class: 'full-logo', name: 'Raiinmaker', url: 'https://www.raiinmaker.com/' },
      { logo: require('@/assets/logos/oxbridgeaq.png'), class: 'logo oxb', name: 'Oxbridge Acquisition', url: 'https://oxbridgeaq.com/' },
      { logo: require('@/assets/logos/bitgo.svg'), class: 'full-logo', name: 'BitGo', url: 'https://www.bitgo.com/' },
      { logo: require('@/assets/logos/zkalyx.png'), class: 'full-logo', name: 'Zkalyx', url: 'https://www.zkalyx.com/' },
      { logo: require('@/assets/korea/sponsors/libera.png'), class: 'logo libera', name: 'Libera Global AI', url: 'https://liberaglobal.ai/' },
      { logo: require('@/assets/logos/pentagon.png'), class: 'full-logo', name: 'Pentagon Games', url: 'https://pentagon.games/' },
      { logo: require('@/assets/logos/inbestgo.svg'), class: 'full-logo', name: 'Inbestgo', url: 'https://inbestgo.com/' },
      { logo: require('@/assets/nashville/sponsors/kredete.png'), class: 'full-logo', name: 'Kredete', url: 'https://www.kredete.com/' },
      { logo: require('@/assets/logos/monoquant.svg'), class: 'logo wolf', name: 'Monoquant', url: 'https://www.monoquant.com/' },
      { logo: require('@/assets/logos/pact.png'), class: 'logo', name: 'Pact Swap', url: 'https://pactswap.io/' },
      { logo: require('@/assets/logos/yieldnest.svg'), class: 'full-logo', name: 'Yield Nest', url: 'https://www.yieldnest.finance/' },
      { logo: require('@/assets/logos/matterfi.svg'), class: 'full-logo', name: 'MatterFi', url: 'https://www.matterfi.com/' },
      { logo: require('@/assets/nashville/sponsors/chintai.png'), class: 'full-logo', name: 'Chintai', url: 'https://chintai.io/' },
      { logo: require('@/assets/korea/sponsors/wow.webp'), class: 'logo', name: 'WOW!?', url: 'https://wow.ai/' },
      { logo: require('@/assets/logos/estatex.png'), class: 'full-logo', name: 'EstateX', url: 'https://www.estatex.eu/' },
      { logo: require('@/assets/logos/wirenetwork.svg'), class: 'full-logo', name: 'Wire Network', url: 'https://www.wire.network/' },
      { logo: require('@/assets/singapore/sponsors/pv.png'), class: 'full-logo', name: 'Persist Ventures', url: 'https://persistventures.com/' },
    ]);
    return {
      partners
    };
  },
};
</script>